import { Box, Typography } from 'hephaestus/web';
import type { OverviewRowProps } from './overviewRow.types';

export const OverviewRow = ({ theme, tokens, row }: OverviewRowProps) => (
  <Box sx={tokens.overviewRowGrid as any}>
    <Typography
      component='div'
      variant='labelSmall'
      sx={{ color: theme.color.onSurfaceVariant, alignSelf: 'start' } as any}
    >
      {row.label}
    </Typography>
    <Typography
      component='div'
      variant='bodySmall'
      sx={{ wordBreak: 'break-word', ...row.style } as any}
    >
      {row.value}
    </Typography>
  </Box>
);
